import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import {
  getIngelogdeGebruiker,
  inloggen as inloggenApi,
  uitloggen as uitloggenApi,
  passkeyLoginStart,
  passkeyLoginVoltooi,
} from '../api/api';
import { bereidLoginVoor, loginNaarJson } from '../util/webauthn';

// Houdt de ingelogde gebruiker bij voor de hele app.
// Bij het laden wordt /api/auth/me aangeroepen: bestaat er een geldige sessie,
// dan ben je ingelogd; zo niet, dan toont App de inlogpagina.
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [gebruiker, setGebruiker] = useState(null);
  const [laden, setLaden] = useState(true);

  const verversGebruiker = useCallback(async () => {
    try {
      const res = await getIngelogdeGebruiker();
      setGebruiker(res.data);
    } catch {
      setGebruiker(null);
    }
  }, []);

  useEffect(() => {
    (async () => {
      await verversGebruiker();
      setLaden(false);
    })();
  }, [verversGebruiker]);

  const login = useCallback(async (email, wachtwoord) => {
    await inloggenApi(email, wachtwoord);      // zet de sessiecookie
    const res = await getIngelogdeGebruiker();  // haal de identiteit op
    setGebruiker(res.data);
  }, []);

  const loginMetPasskey = useCallback(async () => {
    const opties = (await passkeyLoginStart()).data;
    const credential = await navigator.credentials.get(bereidLoginVoor(opties));
    await passkeyLoginVoltooi(loginNaarJson(credential));  // zet de sessiecookie
    const res = await getIngelogdeGebruiker();
    setGebruiker(res.data);
  }, []);

  const logout = useCallback(async () => {
    try {
      await uitloggenApi();
    } catch {
      // sessie kan al verlopen/verwijderd zijn — geen probleem
    }
    setGebruiker(null);
  }, []);

  return (
    <AuthContext.Provider value={{ gebruiker, laden, login, loginMetPasskey, logout, verversGebruiker }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth moet binnen <AuthProvider> gebruikt worden');
  return ctx;
}
